import { getBoroughBackgrounds } from '../api'

const initialState = {
  city: {
    value: "Bogota", label: "Bogotá", key: 'Estrato'
  },
  nyc: [],
  isLoading: true
}

export const cities = ({
  state: initialState,
  reducers: {
    setCity(state, city) {
      return {
        ...state,
        ...city,
        isLoading: false
      }
    }
  },
  effects: {
    changeCity(city) {
      this.setCity({ ...city });
    },
    async loadBoroughBackgrounds() {
      const nyc = await getBoroughBackgrounds()
      this.setCity({nyc: nyc })
    }
  }
})
